import axios from 'axios';
import * as jsonpatch from 'fast-json-patch';

export async function HandleAddBookingWithUser(booking) {
    const url = `api/exlBookingFront/addBookingWithUser?courseId=${booking}`;

    const res = await axios.post(url, booking).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data, status: response.status };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    data: null,
                    status: response.status
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                data: null,
                status: error.response.status,
            };
        }
    );

    return res;
}

export async function HandleAddBooking(booking) {
    const url = 'api/exlBookingFront/addBooking/';

    const res = await axios.post(url, booking).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    data: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                data: null,
            };
        }
    );

    return res;
}

export async function HandleRemoveBooking(bookingId) {
    const url = 'api/exlBookingFront/removeBooking';
    const query = { bookingId: bookingId };

    const response = await axios.delete(url, { params: query }).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, booking: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    booking: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                booking: null,
            };
        }
    );
    return response;
}
export async function HandleRemoveMultipleBookings(bookingIds) {
    const url = 'api/exlBookingFront/removeBookings';

    const response = await axios.delete(url, { data: bookingIds }).then(

        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    data: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                data: null,
            };
        }
    );
    return response;
}

export async function CheckBookingAvailability(courseId, coaEmpId) {
    const params = {
        courseId,
        coaEmpId
    }
    const url = 'api/exlBookingFront/checkBookingAvailability';

    const response = await axios.get(url, { params }).then(
        (response) => {
            if (response.status === 200) {

                return { success: true, error: null, available: response.data, status: response.status };
            } else {

                return {
                    success: false,
                    error: response.data.message,
                    available: false,
                    status: response.status
                };
            }
        },
        (error) => {
            return {
                success: false,
                available: false,
                status: error.response.status,
            };
        }
    )
    return response;
}

export async function HandleUpdateBookings(courseId, existingBookings, newBookings) {
    const url = 'api/exlBookingFront/updateAllBookings/';
    const body = {
        courseId,
        existingBookings,
        newBookingsEmpIds: newBookings.map((newBooking) => newBooking.coaEmpId)
    };

    const response = await axios.post(url, body).then(
        (response) => {
            if (response.status === 200) {

                return { success: true, error: null, booking: response.data, status: response.status };
            } else {

                return {
                    success: false,
                    error: response.data.message,
                    booking: null,
                    status: response.status
                };
            }
        },
        (error) => {
            return {
                success: false,
                booking: null,
                status: error.response.status,
            };
        }
    )
    return response;
}

export async function HandleEmailAllBookings(emailBody, subject, recipients, attachments = []) {
    const url = 'api/exlBookingFront/emailAllBookings/';

    const body = new FormData();
    body.append("emailBody", emailBody);
    body.append("subject", subject);
    recipients.forEach(r => body.append("recipients", r.email));
    attachments.forEach(a => body.append("attachments", a));

    const headers = {};

    if (attachments.length) {
        headers['Content-Type'] = 'multipart/form-data';
    }

    const response = await axios.post(url, body, { headers }).then(
        (response) => {
            if (response.status === 200) {

                return { success: true, error: null, booking: response.data, status: response.status };
            } else {

                return {
                    success: false,
                    error: response.data.message,
                    booking: null,
                    status: response.status
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: error.response.data,
                booking: null,
                status: error.response.status,
            };
        }
    )
    return response;
}

export async function HandlePatchBooking(initialBooking, newBooking) {
    const patch = jsonpatch.compare(initialBooking, newBooking);
    let newPatch = [];

    patch.forEach((operation) => {
        var op = operation;
        op.oldValue = jsonpatch.getValueByPointer(initialBooking, op.path);

        newPatch.push(op);
    });


    const url = 'api/exlBookingFront/patchBooking/';
    const body = {
        id: initialBooking.id,
        EntityId: initialBooking.id,
        serializedPatch: JSON.stringify(newPatch),
    };

    const response = await axios.put(url, body).then(
        (response) => {
            if (response.status === 200) {

                return { success: true, error: null, booking: response.data, status: response.status };
            } else {

                return {
                    success: false,
                    error: response.data.message,
                    booking: null,
                    status: response.status
                };
            }
        },
        (error) => {
            return {
                success: false,
                booking: null,
                status: error.response.status,
            };
        }
    )
    return response;
}

export async function GetBookingById(bookingId) {
    const uri = `api/exlBookingFront/getBookingById/`;
    const params = {
        bookingId,
    };

    const res = await axios.get(uri, { params }).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return { success: false, error: response.data.message, data: null };
            }
        },
        (error) => {
            return { success: false, error: 'Det gick inte att hämta datan, vänligen kontakta alltid@consid.se.', data: null };
        }
    );
    return res.data;
}

export async function GetBookingsByCourseId(courseId) {
    const uri = `api/exlBookingFront/getBookingsByCourseId/`;
    const params = {
        courseId,
    };

    const res = await axios.get(uri, { params }).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return { success: false, error: response.data.message, data: null };
            }
        },
        (error) => {
            return { success: false, error: 'Det gick inte att hämta datan, vänligen kontakta alltid@consid.se.', data: null };
        }
    );
    return res.data;
}

export async function GetAllBookings() {
    const uri = `api/exlBookingFront/getAllBookings/`;

    const res = await axios.get(uri).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return { success: false, error: response.data.message, data: null };
            }
        },
        (error) => {
            return { success: false, error: 'Det gick inte att hämta datan, vänligen kontakta alltid@consid.se.', data: null };
        }
    );
    return res.data;
}

export async function UpdateBookings(courseId, bookings) {
    const uri = `api/exlBookingFront/updateBookings?courseId=${courseId}`;
    const res = await axios.post(uri, bookings, courseId).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data, status: response.status };
            } else {
                return { success: false, error: response.data.message, data: null, status: response.status };
            }
        },
        (error) => {
            return { success: false, error: 'Det gick inte att hämta datan, vänligen kontakta alltid@consid.se.', data: null, status: error.response.status };
        }
    );
    return res;
}

export async function MoveBookings(courseId, originalCourseId, bookingIds) {
    const uri = `api/exlBookingFront/moveBookings`;
    const body = {
        courseId,
        OriginalCourseId: originalCourseId,
        NewBookingsEmpIds: bookingIds
    }

    const res = await axios.post(uri, body).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data, status: response.status };
            } else {
                return { success: false, error: response.data.message, data: null, status: response.status };
            }
        },
        (error) => {
            return { success: false, error: 'Det gick inte att hämta datan, vänligen kontakta alltid@consid.se.', data: null, status: error.response.status };
        }
    );
    return res;
}